import { useState } from 'react';
import './PlaceMarkerByCoords.css';

interface PlaceMarkerByCoordsProps {
  onPlace: (lat: number, lng: number, title: string, color: string) => void;
}

const PlaceMarkerByCoords = ({ onPlace }: PlaceMarkerByCoordsProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [lat, setLat] = useState('');
  const [lng, setLng] = useState('');
  const [title, setTitle] = useState('');
  const [color, setColor] = useState('#3388ff');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    const latitude = parseFloat(lat);
    const longitude = parseFloat(lng);

    if (isNaN(latitude) || isNaN(longitude)) {
      alert('Please enter valid coordinates');
      return;
    }

    if (latitude < -90 || latitude > 90) {
      alert('Latitude must be between -90 and 90');
      return;
    }

    if (longitude < -180 || longitude > 180) {
      alert('Longitude must be between -180 and 180');
      return;
    }

    onPlace(latitude, longitude, title || 'Untitled Marker', color);

    // Reset form
    setLat('');
    setLng('');
    setTitle('');
    setColor('#3388ff');
    setIsOpen(false);
  };

  return (
    <div className="place-marker-by-coords">
      <button
        className="place-marker-button"
        onClick={() => setIsOpen(!isOpen)}
      >
        {isOpen ? '− Cancel' : '📍 Place Marker by Coordinates'}
      </button>

      {isOpen && (
        <form className="coords-form" onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="latitude">Latitude *</label>
              <input
                id="latitude"
                type="number"
                step="any"
                value={lat}
                onChange={(e) => setLat(e.target.value)}
                placeholder="69.265211"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="longitude">Longitude *</label>
              <input
                id="longitude"
                type="number"
                step="any"
                value={lng}
                onChange={(e) => setLng(e.target.value)}
                placeholder="16.047322"
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="marker-title">Title</label>
            <input
              id="marker-title"
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="My Location"
            />
          </div>

          <div className="form-group">
            <label htmlFor="marker-color">Marker Color</label>
            <div className="color-picker-row">
              <input
                id="marker-color"
                type="color"
                value={color}
                onChange={(e) => setColor(e.target.value)}
              />
              <span className="color-value">{color}</span>
            </div>
          </div>

          <button type="submit" className="submit-button">
            Place Marker
          </button>
        </form>
      )}
    </div>
  );
};

export default PlaceMarkerByCoords;
